module.exports = __webpack_public_path__ + "assets/img/add_icon.781d953d.svg";